import { useState } from 'react';
import * as Popper from 'popper.js';
import { Tooltip as ReactstrapTooltip } from 'reactstrap';

export interface TooltipProps {
  id: string;
  children: any;
  text: string;
  placement?: Popper.Placement;
}

const Tooltip = ({ id, children, text, placement = 'right' }: TooltipProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <div>
      <span id={id}>{children}</span>

      <ReactstrapTooltip
        placement={placement}
        isOpen={tooltipOpen}
        target={id}
        toggle={toggle}
      >
        {text}
      </ReactstrapTooltip>
    </div>
  );
};

export default Tooltip;
